import styled from "styled-components";

export const SearchFieldCustomWrapper = styled.div`
  display: flex;
`;

export const SearchFieldCustomLeftWrapper = styled.div`
  .fui-Dropdown {
    min-width: 200px;
    border-right: none;
  }
`;
export const SearchFieldCustomRightWrapper = styled.div`
  width: 100%;
`;
